module.exports = __webpack_public_path__ + "img/tab-4.ba422be0.svg";